const config = {
  sm: {
    screen: "sm",
    device: "mobile",
  },
  md: {
    screen: "md",
    device: "tablet",
  },
  lg: {
    screen: "lg",
    device: "desktop",
  },
};

export function detectWindow(key: "screen" | "device") {
  return window?.innerWidth <= 768 ? config.sm[key] : window?.innerWidth <= 1024 ? config.md[key] : config.lg[key];
}
